/**
 * Playground Page
 * AI image generation, editing, and fusion - matching old admin layout
 */

import { useState } from 'react';
import { OperationPanel, HistoryLibraryPanel } from '@/features/playground';

export type OperationMode = 'generate' | 'edit' | 'fuse' | 'lucky_charm';

export function PlaygroundPage() {
  const [operationMode, setOperationMode] = useState<OperationMode>('generate');
  const [selectedImageForEdit, setSelectedImageForEdit] = useState<{
    id: string;
    image_url: string;
    source: 'history' | 'library' | 'upload';
    base64?: string;
  } | null>(null);
  const [selectedImagesForFuse, setSelectedImagesForFuse] = useState<Array<{
    id: string;
    image_url: string;
    source: 'history' | 'library' | 'upload';
    base64?: string;
  }>>([]);

  return (
    <div className="h-[calc(100vh-4rem)] flex">
      {/* Left Panel: Operations (fixed width 480px) */}
      <div className="w-[480px] border-r border-gray-200 bg-white overflow-y-auto flex-shrink-0">
        <OperationPanel
          operationMode={operationMode}
          onModeChange={setOperationMode}
          selectedImageForEdit={selectedImageForEdit}
          onSelectImageForEdit={setSelectedImageForEdit}
          selectedImagesForFuse={selectedImagesForFuse}
          onSelectImagesForFuse={setSelectedImagesForFuse}
        />
      </div>

      {/* Right Panel: History & Library (flex grow) */}
      <div className="flex-1 overflow-y-auto bg-gray-50">
        <HistoryLibraryPanel
          operationMode={operationMode}
          onModeChange={setOperationMode}
          selectedImageForEdit={selectedImageForEdit}
          onSelectImageForEdit={setSelectedImageForEdit}
          selectedImagesForFuse={selectedImagesForFuse}
          onSelectImagesForFuse={setSelectedImagesForFuse}
        />
      </div>
    </div>
  );
}
